import React from 'react';
import { Outlet } from 'react-router-dom';

import '../../Mobile.css';
function Appointment() {

  return (
    <>
      <Outlet />
    </>
  );
}

export default Appointment